
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reviews/sign-up-bonus",
      function () {
        return require("private-next-pages/reviews/sign-up-bonus/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reviews/sign-up-bonus"])
      });
    }
  